import { Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import dayjs from 'dayjs';

@Component({
	selector: 'formly-field-input',
	template: `
		<vp-date-picker
			[calendarData]="to['calendarData'] || null"
			[config]="{
				defaultDate: to['defaultDate'] || null,
				minDate: to['minDate'] || today,
				maxDate: to['maxDate'] || null,
				showMonths: to['showMonths'] || 1,
			}"
			[formControl]="formControl"
			[hasError]="showError"
			[initialValue]="formControl.value"
			[inputConfig]="{
				disabled: to.disabled,
				icon: to['icon'],
				iconPosition: to['iconPosition'],
				isValid: formControl.valid,
				name: field.id,
				placeholder: to.placeholder,
				readonly: to.readonly,
				defaultStyle: to['defaultStyle'] || true,
				required: to.required,
			}"
			[inputId]="field.id"
			[isLoading]="to['isLoading']"
			[isOptional]="to['optional']"
			[labelSettings]="{
				text: null,
				position: null,
			}"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class DateInputComponent extends FieldType<FieldTypeConfig> {
	today: string = dayjs().format('YYYY-MM-DD');
}
